<template>
  <div class="mb-3">
    <label>{{label || title}}</label>

    <div :title="statusSince">
      Status: {{status}} {{statusMessage}}
    </div>

    <input type="file" :ref="get_file_field_name(name)">

    <div><a :href="fileUrl" target="__blank">{{fileUrl}}</a></div>
    <div v-if="contentType == 'image'">
      <img :src="fileUrl" style="max-width: 300px;">
    </div>
  </div>
</template>

<script>

export default {
	props: [
		'name',
		'value',
		'label',
    'title',
    'content-type'
	],

  components: {},
  watch: {
    value() {
      this.setFileInputValue();
    }
  },

  methods: {
    get_file_field_name(name) {
      return "s3_file_field_" + name
    },
    get_file_field() {
      return this.$refs[this.get_file_field_name(this.name)]
    },
    migrateFileToS3file(fieldValue) {
      // Convert S3 URL to file key by taking part last 2 elements
      // "https://example-s3.com/bucket/path/file.mp4" -> "path/file.mp4"
      let newKey = fieldValue.split("/").slice(-2).join("/")

      let newFieldValue = {
        "status": "ready",
        "key": newKey,
        "url": fieldValue,
        "statusMessage": "",
        "statusUpdatedAt": (new Date().toISOString())
      }

      return newFieldValue
    },
    setFileInputValue() {
      var val = _.get(this.value, this.name);
      if(val instanceof File) {
        var fileInput = this.get_file_field();
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(val);
        fileInput.files = dataTransfer.files;

        if (fileInput.webkitEntries.length) {
            fileInput.dataset.file = `${dataTransfer.files[0].name}`;
        }
      }
    }
  },

	computed: {
    val: {
      get () {
        let fieldValue = _.get(this.value, this.name)

        // Migrate "file" field type URL to "s3file" type data object
        if (typeof fieldValue === 'string' || fieldValue instanceof String) {
          fieldValue = this.migrateFileToS3file(fieldValue)

          // Also set local migrated data for save and send field change event
          let content_item = _.cloneDeep(this.value)
          _.set(content_item, this.name, fieldValue)
          this.$emit("input", content_item)
        }

        return fieldValue
      },
      set (val) {
        let content_item = _.cloneDeep(this.value)
        let fieldValue = val

        // Migrate "file" field type URL to "s3file" type data object
        if (typeof fieldValue === 'string' || fieldValue instanceof String) {
          fieldValue = this.migrateFileToS3file(fieldValue)
        }

        _.set(content_item, this.name, fieldValue)
        this.$emit("input", content_item)
      }
    },

    fileUrl() {
      return _.get(this.val, "url", "")
    },

    // TODO Convert status code to icon/text
    // new
    // uploading
    // processing
    // ready
    // error
    status() {
      return _.get(this.val, "status", "")
    },

    // Get last status update message
    statusMessage () {
      return _.get(this.val, "statusMessage", "")
    },

    // TODO Parse status last update field to human readable date/time text
    // Javascript list data save uses Date.toISOString() for this field
    statusSince () {
      try {
        return (new Date(_.get(this.val, "statusUpdatedAt", ""))).toString()
      } catch (error) {
        console.log("Parsing S3 file field status date failed", error)
        return ""
      }
    }
  },
  mounted() {
    this.setFileInputValue();
  }
}
</script>
